import { LitElement, html } from "lit";
import { customElement, property } from "lit/decorators.js";
import { ListStyles } from "../liststylebuttons/liststylebuttons";

@customElement("result-card")
export class SearchList extends LitElement {
  @property()
  accessor imageUrl = "";
  @property()
  accessor url = "";
  @property()
  accessor title = "";
  @property()
  accessor tag = "";
  @property()
  accessor summary = "";
  @property()
  accessor type = "";
  @property()
  accessor listStyle = ListStyles.GRID_BIG; //Default layout;

  @property()
  accessor newWindow = false;

  @property()
  accessor dictionary: any = {};

  createRenderRoot() {
    return this;
  }

  renderImage(imageUrl: string, altText: string, cssClass: string) {
    if (imageUrl != null && imageUrl != "") {
      if (this.type === "pageProduct") {
        if (this.listStyle === ListStyles.GRID_BIG) {
          return html`<img
            class="${cssClass} object-contain w-[100%] mx-auto p-8 md:p-16"
            src="${imageUrl}"
            alt="${altText}"
          />`;
        } else if (this.listStyle === ListStyles.GRID_SMALL) {
          return html`<img
            class="${cssClass} object-contain w-[100%] mx-auto p-8"
            src="${imageUrl}"
            alt="${altText}"
          />`;
        } else {
          return html`<img
            class="${cssClass} object-contain w-[100%] mx-auto p-8"
            src="${imageUrl}"
            alt="${altText}"
          />`;
        }
      } else {
        return html`<img
          class="${cssClass} object-cover w-full"
          src="${imageUrl}"
          alt="${altText}"
        />`;
      }
    } else {
      return html`<img
        class="${cssClass} object-cover w-full"
        src="/images/placeholders/placeholder.png"
        alt="${altText}"
      />`;
    }
  }
  truncateString(str: string, maxLength: number) {
    if (str.length > maxLength) {
      return str.slice(0, maxLength) + "...";
    } else {
      return str;
    }
  }

  renderTag() {
    if (this.tag != null && this.tag != "") {
      return html`<span
        class="bg-blue-50 tag px-3 pt-2 pb-2.5 absolute top-0 left-0"
        >${this.tag}</span
      >`;
    } else {
      return html``;
    }
  }

  renderCard() {
    const h4MobileClass = "text-[1.375rem]  font-[500] leading-[1.15]";
    const h4DesktopClass = "md:text-[1.625rem] font-[500] md:leading-[1.3]";

    const h5DesktopClass = "md:text-[1.625rem] font-[500] md:leading-[1.3]";

    const baseStyle =
      "relative bg-medium-grey-10 col-span-24 py-6 md:py-0 px-6 -mx-6 max-w-[822px] md:w-full";
    if (this.listStyle == ListStyles.GRID_BIG) {
      this.className =
        baseStyle + " md:col-span-12 md:px-0 md:mx-auto md:w-full";
      return html`
        <a class="flex flex-col flex-wrap min-h-full" href="${this.url}" target="${this.newWindow ? "_blank" : ""}">
          ${this.renderTag()}
          ${this.renderImage(
            this.imageUrl,
            this.title,
            "aspect-[382/286] md:aspect-none md:h-[464px]"
          )}
          <div class="pt-4 md:p-6 md:flex-1">
            <p
              class="${h4MobileClass} ${h4DesktopClass} mb-3 text-darker-blue-100"
              title="${this.title}"
            >
              ${this.title}
            </p>
            <p class="p">
              <span class="line-clamp-3" title="${this.summary}"
                >${this.summary}</span
              >
              <span class="underline group-hover:text-darker-blue-100"
                >${this.newWindow ? JSON.parse(this.dictionary)["readmoreenglish"] : JSON.parse(this.dictionary)["readmore"] ?? ""}</span
              >
            </p>
          </div>
        </a>
      `;
    }

    if (this.listStyle == ListStyles.GRID_SMALL) {
      this.className = baseStyle + " md:col-span-8 lg:col-span-6 md:px-0 md:mx-auto";
      /* Ugly solution because designer cant keep consistent typography */

      return html`
        <a class="block group md:min-h-full" href="${this.url}">
          ${this.renderTag()}
          ${this.renderImage(
            this.imageUrl,
            this.title,
            "w-full aspect-[382/286] md:aspect-none lg:max-w-[291px]  h-[218px]"
          )}
          <div class="pt-4 pb-6 md:p-6">
            <p
              class="${h4MobileClass} md:text-[20px] md:font-medium mb-3 text-darker-blue-100"
              title="${this.title}"
            >
              ${this.title}
            </p>
            <p class="p">
              <span class="line-clamp-3" title="${this.summary}"
                >${this.summary}</span
              >
              <span class="underline group-hover:text-darker-blue-100"
                >${JSON.parse(this.dictionary)["readmore"] ?? ""}</span
              >
            </p>
          </div>
        </a>
      `;
    }

    if (this.listStyle == ListStyles.LIST) {
      this.className =
        baseStyle + " md:col-span-24 md:px-0 md:mx-auto md:w-full";
      return html`
        <a
          class="block md:flex md:min-h-full md:p-6 md:gap-5"
          href="${this.url}"
        >
          ${this.renderTag()}
          ${this.renderImage(
            this.imageUrl,
            this.title,
            "w-full aspect-[382/286] md:aspect-none md:w-[256px] md:h-[194px]"
          )}
          <div class="pt-4 pb-6 md:p-0  md:flex-1">
            <p
              data-attr="title"
              class="${h4MobileClass} ${h4DesktopClass} mb-3 text-darker-blue-100"
              title="${this.title}"
            >
              ${this.title}
            </p>
            <p class="p">
              <span
                class="line-clamp-3"
                data-attr="summary"
                title="${this.summary}"
                >${this.summary}</span
              >
              <span class="underline group-hover:text-darker-blue-100"
                >${JSON.parse(this.dictionary)["readmore"] ?? ""}</span
              >
            </p>
          </div>
        </a>
      `;
    }
    return html``;
  }
  render() {
    return html`${this.renderCard()} `;
  }
}
